import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from '@exo/frontend-common-theme-utils';
import { Chrome } from '@nextgen/frontend-components-templates';
import {
  SessionContextProvider,
  AppShellApolloProvider,
  AuthProvider,
  AppShellMsalProvider,
  FeatureFlagProvider,
  AppErrorBoundary,
  AppShellSwitch,
  PageNotFound
} from '@exo/frontend-common-app-shell';
import { EventContextProvider, EventConnector, useEventContext } from "@nextgen/frontend-features-events-logic";

const RouteAnalytics = () => {
  const location = useLocation();
  const { createEvent } = useEventContext();

  useEffect(() => {
    if (!createEvent) return;
    createEvent({
      eventName: 'page_view',
      page_path: location.pathname,
      page_location: typeof window !== 'undefined' ? window.location.href : undefined,
      page_title: typeof document !== 'undefined' ? document.title : undefined
    });
  }, [createEvent, location.pathname]);

  return null;
};

const Missing = () => (
  <FeatureFlagProvider>
    <AppShellApolloProvider>
      <SessionContextProvider>
        <AppShellMsalProvider>
          <AuthProvider>
            <EventConnector>
              <EventContextProvider>
                <RouteAnalytics />
                <ThemeProvider>
                  <Chrome>
                    <AppErrorBoundary>
                      <PageNotFound />
                    </AppErrorBoundary>
                  </Chrome>
                </ThemeProvider>
              </EventContextProvider>
            </EventConnector>
          </AuthProvider>
        </AppShellMsalProvider>
      </SessionContextProvider>
    </AppShellApolloProvider>
  </FeatureFlagProvider>
)

const Routes = () => (
  <AppShellSwitch missing={Missing} />
);

export default Routes;
